/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { CsMasterRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { InitDialogViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import {
  CSMasterFinderFilter,
  CSMasterFinderListItem,
} from './color-selection-master-finder-list-item.model';

export interface CSMasterFinderDialogConfig extends FinderDialogConfig {
  sourceOfficeId?: ID;
}

@Injectable()
export class CSMasterBusinessService implements InitDialogViewService<CSMasterFinderDialogConfig> {
  constructor(private restService: CsMasterRestService) {
  }

  initDialogView(): any {
    return {};
  }

  findAllAsDataSource(filter: CSMasterFinderFilter): SlicedDataSource<CSMasterFinderListItem> {
    return this.restService.findAllAsDataSource(filter);
  }
}
